import React from 'react';
import {ControlLabel, FormControl, FormGroup, HelpBlock} from 'rsuite';
import s from './CustomField.module.css';

export default class extends React.PureComponent {
    render() {
        const {name, message, label, error, inline = false, formValue=null, formGroupClassName=null, ...props} = this.props;
        let formGroupClasses = [];

        if (error) {
            formGroupClasses.push('has-error');
        }

        if (inline) {
            formGroupClasses.push(s.inline);
        }

        if (formGroupClassName) {
            formGroupClasses.push(formGroupClassName);
        }


        return (
            <FormGroup className={formGroupClasses.join(" ")}>
                {
                    ( () => label ? <ControlLabel className={s.label}>{label}</ControlLabel> : <></> )()
                }
                <div className={s.field}>
                    <FormControl
                        className={s.input}
                        name={name}
                        errorMessage={error}
                        {...props}
                    />
                </div>
                {(() => message ? <HelpBlock>{message}</HelpBlock> : <></>)()}
            </FormGroup>
        )
    }
}